import { FormControl } from '@angular/forms';
import {
  BenchmarkCurve,
  FlexColumn,
  MuniUserSettingsModel,
} from '../models/muni-user-settings.model';

export const INITIAL_USER_SETTINGS: MuniUserSettingsModel = {
  defaultBenchmarkCurve: BenchmarkCurve.MmdInterpolated,
  defaultFlexColumn: FlexColumn.Sector,
  defaultDealCardsView: false,
};

export const getSettingsFormControls = (settings: MuniUserSettingsModel) => {
  const controls: { [key: string]: FormControl } = {};

  Object.keys(settings).forEach((key) => {
    controls[key] = new FormControl(settings[key]);
  });

  return controls;
};
